// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mz-0";